import {mapFilters} from "@/utils/helpers";

const initState = () => ({
  orderCreatingInProgress : false
})

export const state = initState

export const getters = {
}

export const mutations = {
  setOrderCreatingInProgress(state, inProgress){
    state.orderCreatingInProgress = inProgress
  }
}

export const actions = {
  async fetchCustomizableOrders({commit, state}, {pagingInfo, filters, showClosedOrders}){
    const url = `/webpos/customizable-order/`;
    let customOrders = [];

    let filter = mapFilters(filters, pagingInfo.pageNo, pagingInfo.pageSize, pagingInfo.sortBy, pagingInfo.sortAsc);
    filter.showClosedOrders = showClosedOrders;
    const result = await this.$axios.$post(url, filter);

    if(result && !result.hasErrors){
      customOrders = result;
    }
    else{
      this.$toast.error('Error while getting custom orders')
    }
    return customOrders;
  },

  async fetchServices(){
    let serviceTypes = [];
    try{
      const result = await this.$axios.$get(`/webpos/customizable-order/services`)
      if (!result?.value || result.apiMessages?.hasErrors) {
        this.$toast.error('Error while getting service types')
      }
      else{
        serviceTypes = result.value;
      }
    }
    catch(e){
      this.$toast.error('Error while getting service types')
    }
    return serviceTypes
  },

  async updateCustomOrderInstructions({}, {orderId, customItemId, memo, jobTypeCode}){
    try{
      await this.$axios.put(`/webpos/customizable-order/memo`, {
        orderId: orderId,
        customItemId: customItemId,
        memo: memo,
        jobTypeCode: jobTypeCode,
      });

      this.$toast.success("Custom order memo updated successfully");
    }
    catch(error){
      this.$toast.error("Error while updating custom order memo");
    }
  },

  async getCustomOrderByID({}, {orderID, storeID}){
    let itemType = null;
    try{
      const result = await this.$axios.$get(
        `/webpos/customizable-order/${orderID}?storeID=${storeID}`);

      if(result && !result.hasErrors){
        itemType = result.value;
      }

      else{
        this.$toast.error('Error while getting selected custom order');
      }
    }
    catch(e){
      if(e.response.status === 404){
        this.$toast.error('The selected custom order does not exist in the current store');
        return itemType
      }
      this.$toast.error('Error while getting selected custom order');
    }
    return itemType;
  },

  async getInitialCustomizableOrderData({}, jobTypeCode){
    let initialData = null;
    try{
      const result = await this.$axios.$get(
        `/webpos/customizable-order/initial-data?jobTypeCode=${jobTypeCode}`);

      if(result && !result.hasErrors){
        initialData = result.value;
      }

      else{
        this.$toast.error('Error while initializing custom order data');
      }
    }
    catch(e){
      this.$toast.error('Error while initializing custom order data');
    }
    return initialData;
  },

  async updateCustomOrder({commit}, {id, customOrder}){
    commit('setOrderCreatingInProgress', true)
    let success = true;
    try{
      await this.$axios.$post(`/webpos/customizable-order/${id}`, customOrder);
      this.$toast.success('Custom order updated successfully');
    }
    catch(e){
      this.$toast.error('Error while updating custom order data');
      success = false;
    }
    finally {
      commit('setOrderCreatingInProgress', false)
    }
    return success;
  },
}
